import React from 'react';

import {useDispatch, useSelector} from 'react-redux';
import Cart from "./components/Cart";

import {
  changeParameter,
  addToCart,
} from './data/slice'

export default () => {
  const dispatch = useDispatch();

  const {
    parameters,
    quote,
  } = useSelector((state) => state.smc)

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({name, value}))
  }

  const onAddToCart = () => dispatch(addToCart());

  return (
    <Cart
      parameters={parameters}
      quote={quote}
      onChangeParameter={onChangeParameter}
      onAddToCart={onAddToCart} />
  )
}
